<template>
  <div>
    <base-header class="header pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 d-block d-md-none">
            <router-link
              :to="'/'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para o início"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
        </div>
      </div>
      <div
        class="col-xl-10 offset-xl-1 col-xl-10 col-lg-12 mb-5"
        shadow
        footerClasses="py-2 text-center"
        bodyClasses="p-1"
        ref="loader_collaborator"
      >
        <template>
          <div class="row text-center">
            <div class="col-md-4 mt-2">
              <img
                v-if="user.profilePicture"
                :src="user.profilePicture.url"
                width="200"
                height="200"
                class="rounded-circle"
                alt="..."
              />
              <img
                v-else
                src="/img/pages/default_banner_course.jpg"
                width="200"
                height="200"
                class="rounded-circle"
                alt="..."
              />
            </div>
            <div class="col-md-8 text-left">
              <h1 class="mt-3 text-white">{{ user.name }}</h1>
              <div class="text-white font-weight-400 font-size-18 mb-1">
                <i class="fas fa-briefcase text-white"></i> {{ user.position }}
              </div>
              <div class="text-white font-weight-400 font-size-18 mb-1">
                {{ user.short_bio }}
              </div>
            </div>
          </div>
        </template>
      </div>
    </base-header>
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col-xl-4 col-lg-4">
          <div class="shadow mb-4 card">
            <div slot="header">
              <h3 class="mb-0 text-center mt-3">
                Sobre {{ user.name ? user.name.split(" ", 1)[0] : "" }}
              </h3>
            </div>
            <hr class="my-2" />
            <div class="mx-3">
              <p v-if="user.start_at" class="mt-lg-3 mt-xl-3 mt-md-3">
                Entrou em {{ formatDate(user.start_at, "MM/YYYY") }} ({{
                  getAge(user.start_at)
                }}
                anos)
              </p>
              <p v-if="user.birth" class="mt-lg-3 mt-xl-3 mt-md-3">
                Faz aniversário em {{ formatDate(user.birth, "DD/MM") }} ({{
                  getAge(user.birth)
                }}
                anos)
              </p>
              <p v-if="user.city && user.state" class="mt-lg-3 mt-xl-3 mt-md-3">
                Mora em {{ user.city }} - {{ user.state }}
              </p>
              <h4 class="mt-lg-3 mt-xl-3 mt-md-3">
                Categorias:
                <span
                  v-for="category in user.categories"
                  :key="category.id"
                  class="font-weight-light"
                  >{{ category.title }};
                </span>
              </h4>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <email-link :emailAddress="user.user.email" />
                </div>
              </div>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <whatsapp-link :phoneNumber="user.phone" />
                </div>
              </div>
              <div v-if="user.homepage_url">
                <div class="h5 font-weight-300 mb-1">
                  <a :href="user.homepage_url" title="Acessar homepage"
                    ><i class="fas fa-laptop"></i> {{ user.homepage_url }}</a
                  >
                </div>
              </div>
              <div v-if="user.facebook_url">
                <div class="h5 font-weight-300 mb-1">
                  <a :href="user.facebook_url" title="Acessar homepage"
                    ><i class="fab fa-facebook-square"></i> /{{
                      user.facebook_url.split(".com/", 2)[1]
                    }}</a
                  >
                </div>
              </div>
              <div v-if="user.instagram_url">
                <div class="h5 font-weight-300 mb-1">
                  <a :href="user.instagram_url" title="Acessar homepage"
                    ><i class="fab fa-instagram"></i> @{{
                      user.instagram_url.split(".com/", 2)[1]
                    }}</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="shadow mb-4 card">
            <div slot="header">
              <h3 class="mb-0 text-center mt-3">Colegas</h3>
            </div>
            <hr class="my-2" />
            <div class="mx-3">
              <div class="d-flex justify-content-between">
                <span class="float-left"
                  >{{ collaborators.length }} colegas</span
                >
                <router-link class="float-right" to="/colaborador/colaboradores"
                  >Ver todos</router-link
                >
              </div>

              <div class="row mt-2">
                <div
                  class="col-6 text-center"
                  :key="index"
                  v-for="(collaborator, index) in collaborators"
                >
                  <div>
                    <img
                      v-if="collaborator.profilePicture"
                      :src="collaborator.profilePicture.url"
                      @click="
                        $router.push(
                          `/colaborador/colaboradores/${collaborator.user_id}/visualizar`
                        )
                      "
                      width="100"
                      height="100"
                      class="rounded click-name"
                      alt="..."
                    />
                    <img
                      v-else
                      @click="
                        $router.push(
                          `/colaborador/colaboradores/${collaborator.user_id}/visualizar`
                        )
                      "
                      src="/img/pages/default_banner_course.jpg"
                      width="100"
                      height="100"
                      class="rounded click-name"
                      alt="..."
                    />
                    <h5
                      @click="
                        $router.push(
                          `/colaborador/colaboradores/${collaborator.user_id}/visualizar`
                        )
                      "
                      class="click-name font-weight-200"
                    >
                      {{ collaborator.name }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-8 col-lg-8">
          <div class="px-0">
            <new-post
              v-if="user.user_id === Number(user_id)"
              :profile_picture="
                userSelf.profilePicture ? userSelf.profilePicture.url : ''
              "
              :user="userSelf"
              @news="loadPublications"
              endpoint="colaborador"
            />
          </div>
          <div ref="news_feed" :key="event.id" v-for="(event, index) in news">
            <div class="shadow mb-4 card px-2">
              <p class="mb-2 mt-2">
                <a @click="handleViewUser(event)" class="click-name">
                  <img
                    width="30"
                    height="30"
                    v-if="event.profile_picture"
                    :src="event.profile_picture"
                    class="rounded-circle"
                    alt="foto de perfil"
                  />
                  <i v-else class="fas fa-user-circle user-default-logo"></i>
                  <span class="ml-2">{{
                    event.collaborator_name
                      ? event.collaborator_name
                      : event.company_name
                  }}</span>
                </a>
                <i
                  v-if="isSelfEdit(event)"
                  @click="
                    $router.push(`/colaborador/publicacoes/${event.id}/editar`)
                  "
                  v-tooltip="'Editar publicação'"
                  class="fas fa-edit float-right pointer mr-2"
                ></i>
              </p>

              <p class="mb-2">
                <span class="font-date float-right">{{
                  formatDate(event.created_at, "LL")
                }}</span>
              </p>
              <img
                v-if="event.image_url"
                class="image-feed rounded mx-auto d-block col-12 px-0"
                :src="event.image_url"
                alt="..."
              />
              <quill-editor
                v-model="event.body"
                :options="editorReadOnly"
                disabled="disabled"
              >
              </quill-editor>

              <div class="btn-group mb-3 d-flex border-group">
                <base-button
                  class="btn btn-white py-1"
                  :title="!event.liked ? 'Curtir' : 'Descurtir'"
                  @click="handleLike(index)"
                >
                  <div v-if="!event.liked" class="">
                    <i class="far fa-heart fa-sm"></i>
                    {{ event.likes }}
                  </div>
                  <div v-else class="">
                    <i class="fas fa-heart fa-sm text-primary"></i>
                    {{ event.likes }}
                  </div>
                </base-button>
                <base-button
                  class="btn btn-white py-1"
                  type=""
                  @click="
                    $router.push(
                      `/colaborador/publicacoes/${event.id}/visualizar`
                    )
                  "
                >
                  <i class="far fa-comment fa-sm"></i> {{ event.comments }}
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NewPost from "@/components/PostNew.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { getUserId } from "@/services/auth";
import api from "@/services/api";
export default {
  name: "call-card",
  components: { quillEditor, NewPost },
  data() {
    return {
      bgClasses: [
        "warning",
        "info",
        "primary",
        "success",
        "secondary",
        "danger",
        "light",
        "dark"
      ],
      user: {},
      userSelf: {},
      news: [],
      user_id: getUserId(),
      collaborators: [],
      editorReadOnly: {
        placeholder: "...",
        readOnly: true,
        theme: "bubble"
      }
    };
  },
  async mounted() {
    await this.loadUser();
    await this.loadUserSelf();
    await this.loadPublications();
    await this.loadCollaborators();
  },
  methods: {
    isSelfEdit(news) {
      const id = news.collaborator_id ? news.collaborator_id : news.company_id;
      return Number(id) === Number(this.user_id);
    },
    handleViewUser(news) {
      this.$router.push(
        news.collaborator_id
          ? `/colaborador/colaboradores/${news.collaborator_id}/visualizar`
          : `/colaborador/empresa/${news.company_id}/visualizar`
      );
    },
    async loadCollaborators() {
      const loader = this.$loading.show({
        container: this.$refs.loader_collaborator,
        loader: "dots",
        width: 90,
        height: 90,
        opacity: 0
      });
      try {
        const {
          data: { collaborators }
        } = await api.get(`/collaborator/collaborators?&limit=6`);
        if (collaborators) {
          this.collaborators = collaborators;
        }
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar os colegas`);
      }
    },
    getAge(birth) {
      return (
        this.moment().year() -
        parseInt(this.moment(birth, "YYYY-MM-DD").format("YYYY"))
      );
    },
    async handleLike(index) {
      if (!this.news[index].liked) {
        this.news[index].likes += 1;
      } else if (this.news[index].liked && this.news[index].likes > 0) {
        this.news[index].likes -= 1;
      }
      this.news[index].liked = !this.news[index].liked;
      try {
        await api.put(`/collaborator/news/${this.news[index].id}/like`);
      } catch (error) {
        this.news[index].likes -= 1;
        this.news[index].liked = !this.news[index].liked;
        this.$toasted.error("Falha ao curtir");
      }
    },
    async loadUser() {
      const loader = this.$loading.show({
        container: this.$refs.loader_collaborator,
        loader: "dots",
        width: 90,
        height: 90,
        opacity: 0
      });
      try {
        const { data } = await api.get(
          `/collaborator/collaborators/${this.$route.params.id}`
        );
        if (data) {
          this.user = data;
        }
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar o perfil`);
      }
    },
    async loadUserSelf() {
      const loader = this.$loading.show({
        container: this.$refs.loader_collaborator,
        loader: "dots",
        width: 90,
        height: 90,
        opacity: 0
      });
      try {
        const { data } = await api.get(
          `/collaborator/collaborators/${this.user_id}`
        );
        if (data) {
          this.userSelf = data;
        }
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar o perfil`);
      }
    },
    async loadPublications(errorMsg) {
      const loader = this.$loading.show({
        container: this.$refs.news_feed,
        loader: "dots",
        width: 90,
        height: 90,
        opacity: 0
      });
      try {
        const {
          data: { data, meta }
        } = await api.get(`/collaborator/news/user/${this.$route.params.id}`);
        if (data.length) {
          this.news = data;
          this.meta = meta;
        } else {
          this.news = [];
        }
        loader.hide();
      } catch (e) {
        this.$toasted.error(`Ocorreu um erro ao recuperar ${errorMsg}`);
      }
    },
    tasksSubmissions() {
      let submissionCount = 0;
      this.tasks.forEach(task => {
        if (task.submission.length) {
          submissionCount += 1;
        }
      });
      return submissionCount;
    }
  },
  watch: {
    "$route.params.id": async function() {
      await this.loadUser();
      window.scrollTo(0, 0);
      await this.loadPublications();
      await this.loadCollaborators();
    }
  }
};
</script>
<style scoped>
.font-date {
  font-size: 0.8rem;
  color: #8c8c8c;
}
.card-profile-stats > div .heading {
  font-size: 1rem;
}
.card {
  border-radius: 15px;
}

.border-group {
  border-radius: 10px;
  border: 2px solid #eaeaea;
}
.click-name {
  cursor: pointer;
}
.user-default-logo {
  font-size: 30px;
  vertical-align: middle;
}
</style>
